import React from 'react';
import styles from '../../../styles/portfolio/link.scss';
// import {useNavigate} from "react-router-dom";


export const Link = props => {
    // const navigate = useNavigate();

    const scrollToSection = (elementRef) => {
        elementRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }

    function openInNewTab(url, innerSection) {
        if (url) {
            window.open(url, '_blank');
        } else {
            redirectInWebsite(innerSection);
        }
    }

    function redirectInWebsite(sectionRef) {
        // navigate("/portfolio/distributed-counter#" + innerSection);
        scrollToSection(sectionRef)
    }

    return (
        <span className={styles.container} onClick={() => openInNewTab(props.url, props.section)}>
            {props.text}
        </span>
    )
};
